import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface UserSummary {
  user_id: string;
  phone: string | null;
  email: string | null;
  display_name: string | null;
}

interface AuthState {
  token: string | null;
  anonymousId: string | null;
  userSummary: UserSummary | null;

  setAuth: (params: { token: string; userSummary: UserSummary }) => void;
  setUserSummary: (summary: UserSummary) => void;
  setAnonymousId: (id: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      anonymousId: null,
      userSummary: null,

      setAuth: ({ token, userSummary }) => set({ token, userSummary }),
      setUserSummary: (userSummary) => set({ userSummary }),
      setAnonymousId: (anonymousId) => set({ anonymousId }),
      clearAuth: () => set({ token: null, userSummary: null }),
    }),
    {
      name: "seiwa.auth.v1",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        token: state.token,
        anonymousId: state.anonymousId,
        userSummary: state.userSummary,
      }),
    },
  ),
);
